import { ACTION_TYPE } from './constants';

export const loadFonts = () => ({
  type: ACTION_TYPE,
  chrome: {
    message: 'get_installed_fonts'
  }
});
